<script>
import List from "@/components/molecules/list";
import ListItemNavigation from "@/components/molecules/list-item-navigation";

export default {
  name: "RecettesMobile",
  components: { List, ListItemNavigation }
};
</script>

<template>
  <div>
    <list>
      <ListItemNavigation
        class="u-full-width"
        to="/recettes"
        no-border
      >
        Catalogue de recettes
      </ListItemNavigation>
      <ListItemNavigation
        class="u-full-width"
        to="/mes-repas"
        no-border
      >
        Mes repas
      </ListItemNavigation>
      <ListItemNavigation
        class="u-full-width"
        to="/recettes-favorites"
        no-border
      >
        Mes recettes favorites
      </ListItemNavigation>
      <ListItemNavigation
        class="u-full-width"
        to="/mes-recettes-personnelles"
        no-border
      >
        Mes recettes personnelles
      </ListItemNavigation>
    </list>
  </div>
</template>

<style lang="scss" scoped>
</style>
